import { render, staticRenderFns } from "./PaymentResult.vue?vue&type=template&id=47a6faae&scoped=true&"
import script from "./PaymentResult.vue?vue&type=script&lang=js&"
export * from "./PaymentResult.vue?vue&type=script&lang=js&"
import style0 from "./PaymentResult.vue?vue&type=style&index=0&id=47a6faae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a6faae",
  null
  
)

export default component.exports